import { createActions } from 'redux-actions';
import { request } from '../../services';
import { navigate } from 'actionCreators';

const {
  requestRefigureFormRequest,
  requestRefigureFormSuccess,
  requestRefigureFormFailure,
} = createActions({
  REQUEST_REFIGURE_FORM_SUCCESS: json => ({
    refigure: json.refigure,
  }),
}, 'REQUEST_REFIGURE_FORM_REQUEST', 'REQUEST_REFIGURE_FORM_FAILURE');

export function requestRefigureForm() {
  return (dispatch) => {
    dispatch(requestRefigureFormRequest());
    return request('refigures')
      .then(({ json }) =>
        dispatch(requestRefigureFormSuccess(json)),
      )
      .catch(error => dispatch(requestRefigureFormFailure(error)));
  };
}

const {
  submitRefigureFormRequest,
  submitRefigureFormSuccess,
  submitRefigureFormFailure,
} = createActions('SUBMIT_REFIGURE_FORM_SUCCESS', 'SUBMIT_REFIGURE_FORM_REQUEST', 'SUBMIT_REFIGURE_FORM_FAILURE');

export function submitRefigureForm(refigure) {
  return (dispatch) => {
    dispatch(submitRefigureFormRequest());
    return request('refigures', { method: 'POST', body: { refigure } })
      .then(() => {
        dispatch(submitRefigureFormSuccess());
        dispatch(navigate('/refigure/thankyou'));
      })
      .catch(error => dispatch(submitRefigureFormFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/refigure_form.js